import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/root'
import { LangFile } from './'

const Texts:LangFile = {
  // #region | General
  additional: "additional", //NEW 17-04-2026
  and: "y",
  change: "cambiar",
  choose: "elegir",
  deleteFailed: "delete failed", //NEW 03-03-2026
  editFailed: "edit failed", //NEW 03-03-2026
  filterBy: "filtrar por",
  from: "desde",
  general: "general", // NEW 17-11-2025
  no: "no",
  noData: "Sin datos",
  noOptions: "Sin opciones",
  of: "de",
  off: "apagado",
  on: "encendido",
  optional: "opcional",
  page: "página",
  reset: "restablecer",
  required: "obligatorio",
  saveAlert: "Guarda o cancela la vista de edición.",
  search: "Buscar",
  select: "Seleccionar",
  success: "Éxito",
  to: "a",
  unknown: "unknown", //NEW 07-05-2026
  wasUpdated: "was updated", //NEW 05-03-2026
  wasDeleted: "was deleted", //NEW 05-03-2026
  useSelectedTime: "usar hora seleccionada",
  yes: "sí",
  // #endregion
  
  // Regarding the language list:
  // Please translate only your own language. 
  // If your language is not on the list, then add it using a maximum of two 
  // initials followed by a colon and the language in quotation marks.
  languages: {
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "普通话",
    ko: "한국어",
    nl: "nederlands",
  },

  cookie: {
    header: "cookies",
    context1: "Agrisys A/s utiliza cookies para los siguientes fines:",
    context2: "Al pulsar \"Aceptar todo\" aceptas nuestro uso de cookies. De lo contrario, se utilizará un mínimo de cookies necesarias para que el servicio funcione, por ejemplo, para gestionar el inicio de sesión y la obtención de datos desde la plataforma consys.",
    purpose1: "Apoyar la funcionalidad del sitio web, por ejemplo, recordando tu configuración respecto a cookies, idiomas preferidos, monedas, etc.",
    purpose2: "Realizar análisis estadísticos de tu uso del sitio web, por ejemplo, midiendo qué tipo de contenido ves y en qué haces clic.",
    accept: "Aceptar necesarias",
    acceptAll: "Aceptar todo"
  },

  // #region | Units
  units: {
    animal: "animal",
    animals: "animales",
    units: "unidades",
    capacity: "capacidad",
    cup: "cup", //NEW 07-05-2026
    cups: "cups", //NEW 07-05-2026
    date: "date", // NEW 30-01-2026
    day: "día",
    days: "días",
    g: "g",
    hour: "hora",
    hourAgo: "hace una hora",
    hours: "Horas",
    hoursAgo: "hace horas",
    kg: "kg",
    minutAgo: "hace un minuto",
    minutesAgo: "hace minutos",
    min: "min",
    milisec: "milisec", //NEW 08-05-2026
    pct: "PCT",
    sec: "seg", //NEW 04-12-2025
    time: "tiempo",
    times: "veces",
    timeToday: "vez hoy",
    timesToday: "veces hoy",
    total: "total",
    energy: "energía",
    gramPerMinute: "gramos por minuto",
    lenght: "longitud"
  },
  // #endregion

  // #region | Buttons
  buttons: {
    add: "añadir",
    apply: "aplicar",
    cancel: "cancelar",
    commit: "confirmar",
    confirm: "confirmar",
    create: "crear",
    csv: "csv",
    deselectAll: "deseleccionar todo",
    details: "detalles",
    edit: "editar",
    excel: "excel",
    filter: "Filtrar",
    goBack: "volver",
    menu: "menú",
    move: "mover",
    next: "siguiente",
    options: "opciones",
    prev: "anterior",
    print: "imprimir",
    resetFilters: "restablecer filtros",
    save: "guardar",
    selectAll: "seleccionar todo"
  },
  // #endregion

  // #region | Menu Headers
  menuHeaders: {
    overview: "visión general",
    globalMenu: "menú global",
    systemMenu: "menú del sistema",
    attentions: "avisos",
    quickEntry: "entrada rápida",
    language: "idioma",
    [Pages.dashboard]: "panel",
    [Pages.kpi]: "kpi",
    [Pages.feedCurves]: "curvas de alimentación",
    [Pages.components]: 'componentes',
    [Pages.componentsAlternatives]: "alternativas de componentes",
    [Pages.mixtures]: "mezclas",
    [Pages.silos]: "silos",
    [Pages.silosSettings]: "configuración de silos",
    [Pages.animals]: "animales",
    [Pages.animalsGroups]: "grupos de animales",
    [Pages.reports]: "informes",
    [Pages.archive]: 'archivo',
    [Pages.logbook]: "registro",
    [Pages.globalSettings]: "configuración",
    [Pages.devices]: "dispositivos",
    [Pages.freeda_lf]: "visión general",
    [Pages.freeda_lf_sections]: 'locations', // OBS: CHANGED FROM SECTIONS 24/02/2026 !!!!!!!!!! [Pages.freeda_lf_sections]: 'secciones',
    [Pages.freeda_lf_settings]: 'configuración',
    [Pages.op_operations]: 'operaciones',
    [Pages.op_quickEntry]: 'Entrada rápida',
    [Pages.freeda_esf]: "visión general",
    [Pages.freeda_esf_sections]: "locations", // OBS: CHANGED FROM SECTIONS 24/02/2026 !!!!!!!!!! [Pages.freeda_esf_sections]: "secciones",
    [Pages.freeda_esf_settings]: "configuración"
  },
  // #endregion

  // #region | User
  user: {
    userInformation: "información del usuario",
    user: "usuario",
    userName: "Nombre de usuario",
    firstName: "Nombre",
    lastName: "Apellidos",
    phone: "Teléfono",
    email: "Correo electrónico",
    password: "Contraseña",
    repeatPassword: "Repetir contraseña",
    country: "País",
    address: "Dirección"
  },
  // #endregion

  // #region | Farm
  farm: {
    farmInformation: "información de la granja",
    farmName: "nombre de la granja",
    city: "ciudad",
    street: "calle",
    phone: "teléfono",
    vat: "IVA",
    email: "correo electrónico"
  },
  // #endregion

  // #region | Milestones
  milestones: {
    general: {
      milestone: "hito",
      milestones: "hitos",
      noMilestoneFound: "no se encontró ningún hito",
      animalsInMilestones: "animales en hitos",
      latestMilestone: "hito actual",
      milestoneDay: "día del hito actual",
      newMilestone: "Nuevo hito"
    },
    defaultMilestones: {
      farrowing: "Parto",
      insemination: "Inseminación",
      weaning: "Destete",
      movedToFarrowing: "Trasladado a parto"
    }
  },
  // #endregion

  // #region | Events
  events: { 
    events: "events", //NEW 16-01-2026
    eventType: "type", //NEW 16-01-2026
    eventDate: "date", //NEW 16-01-2026
    eventNote: "note", //NEW 16-01-2026
    eventTime: "time", //NEW 16-01-2026
    typeMissing: "type missing", //NEW 16-01-2026
    dateMissing: "date missing", //NEW 16-01-2026
    noteMissing: "note missing", //NEW 16-01-2026
    addEvent: "add event", //NEW 16-01-2026
    animal: "animal", //NEW 16-01-2026
  },
  // #endregion

  // #region | Devices
  devices: {
    devices: "dispositivos",
    name: "nombre",
    cpuId: "id de cpu",
    type: "Tipo",
    connection: "conexión",
    system: "sistema",
    noControllersFound: "no se encontraron controladores LAN",
    lanControllers: "controladores LAN",
    newLcBoard: "nueva placa LC",
    boardName: "nombre de la placa",
    boardNameMissing: "board name missing", //NEW 16-12-2025
    powerSupplyMissing: "power supply missing", //NEW 16-12-2025
    maxAcPortsMissing: "max ac ports missing", //NEW 16-12-2025
    noIoBoards: "no se encontraron placas de E/S",
    ioBoards: "placas de E/S",
    newIoBoard: "nueva placa de E/S",
    layout: "distribución",
    horizontal: "Horizontal",
    vertical: "Vertical",
    asc: "Ascendente",
    desc: "Descendente",
    columns: "columnas",
    rows: "filas",
    order: "orden",
    direction: "dirección",
    chooseIo: "elegir E/S",
    chooseRfidIo: "Choose RFID Reader I/O", //NEW 03-03-2026
    remainingInputs: "entradas restantes",
    remainingOutputs: "salidas restantes",
    aicoIo: "Placa de E/S",
    output: "Salida",
    input: "Entrada",
    board: "placa",
    moveBoard: "mover placa",
    noTerminals: "Sin terminales",
    terminalPort: "Puerto del terminal",
    pen: "Corral",
    ioSpecifications: "especificaciones de E/S",
    numbering: "numeración",
    manual: "manual",
    automatic: "automático",
    pattern: "patrón",
    topLeft: "arriba izquierda",
    topRight: "arriba derecha",
    bottomLeft: "abajo izquierda",
    bottomRight: "abajo derecha",
    startCorner: "esquina inicial",
    noLanController: "Sin controlador LAN",
    noCpuId: "Sin id de cpu",
    noSystem: "Sin sistema",
    server: "Server", //NEW 21-04-2026
  },
  // #endregion

  // #region | System Controls
  systemControls: {
    general: {
      startSystem: "iniciar sistema",
      systemControls: "controles del sistema",
      emergencyStop: "parada de emergencia",
      stopSystem: "detener sistema",
      startAll: "iniciar todo",
      startSection: "iniciar sección",
      startSelected: "iniciar seleccionados",
      calibrateSection: "calibrar sección",
      calibrateSelected: "calibrar seleccionados",
      emptySection: "vaciar sección",
      emptySelected: "vaciar seleccionados",
      clickPen: "Haz clic en cada corral que quieras seleccionar",
      clickStation: "Click every station you want to select", // NEW 07-05-2026
      unClickPen: "Haz clic en cada corral que quieras deseleccionar",
      orSelectAll: "O seleccionar todo",
      orDeselectAlle: "O deseleccionar todo",
      problem: "problema",
      problems: "problemas",
      warning: "advertencia",
      warnings: "advertencias",
      attention: "aviso",
      attentions: "avisos",
      attentionType: "Tipo de aviso",
      systemState: "Estado del sistema",
      staticFeeding: "Alimentación estática",
      nextFeeding: "Siguiente alimentación",
      resolvedWeight: "peso resuelto",
      noPensSelected: "No hay corrales seleccionados",
      noStationsSelected: "No stations selected", // NEW 07-05-2026
      feeding: "Alimentación",
      feedingFailed: "Error en la alimentación",
      calibrating: "Calibrando",
      calibratingFailed: "Error al calibrar",
      changeTime: "Cambiar hora",
      emptying: "Emptying", // NEW 07-04-2026
      emptyingFor: "Vaciando por",
      emptyingFailed: "Error al vaciar",
      controls: "Controls", // NEW 07-04-2026
      confirmStop: "¿Quieres proceder con la parada de emergencia del sistema?",
      goToSystem: "ir al sistema",
      systemStatus: "estado del sistema",
      date: "fecha",
      level: "nivel",
      type: "tipo",
      inspect: "inspeccionar",
      delete: "eliminar",
      logid: "id de registro",
      system: "Sistema",
      motor: "Motor",
      animal: "Animal",
      alerts: "alertas",
      location_name: "Nombre de la ubicación",
      fk_lan_controllers: "FK controladores LAN",
      lan_controller_log_id: "ID de registro del controlador LAN",
      attention_message: "Mensaje de aviso",
      attention_time: "Hora del aviso",
      runningWith: "funcionando con",
      technicalData: "Datos técnicos",
      startLocation: "start location", // NEW 07-05-2026
      calibrateLocation: "calibrate location", // 07-05-2026
      gateControl: "gate control", // NEW 07-05-2026
      autotuneAntenna: "autotune antenna", // NEW 07-05-2026
      openGate: "open gate", // NEW 07-05-2026
      closeGate: "close gate", // NEW 07-05-2026
      blockGate: "block gate", // NEW 07-05-2026
      unblockGate: "unblock gate", // NEW 07-05-2026
      autotuneSelected: "autotune selected", // NEW 07-05-2026
      autoTuneFailed: "autotune failed" // NEW 08-05-2026
    },
    states: {
      [AttentionTypes.good]: "En ejecución",
      [AttentionTypes.neutral]: "Apagado",
      [AttentionTypes.warning]: "Advertencia",
      [AttentionTypes.alert]: "Alerta"
    },
    createSystem: {
      createNewSystem: "create new system", // NEW 27-11-2025
      systemName: "system name", // NEW 27-11-2025
      systemType: "system type", // NEW 27-11-2025
      systemNameMissing: "system name missing", // NEW 27-11-2025
      systemTypeMissing: "system type missing", // NEW 27-11-2025
      systemLimitReached: "system limit reached", // NEW 28-01-2026
      createSystem: "create system" // NEW 27-11-2025
    },
    blueprint: {
      blueprint: "blueprint", // NEW 09-01-2026
      upload: "upload", // NEW 09-01-2026
      wrongType: "Error processing file", // NEW 09-01-2026
      wrongSize: "File is too large (max 500 kB)", // NEW 09-01-2026
      pleaseDropImage: "Please drop a JPEG file", // NEW 09-01-2026
      pleaseSelectImage: "Please select a JPEG file", // NEW 09-01-2026
      dropImage: "Drag and drop your blueprint here", // NEW 09-01-2026
      browseImage: "Or browse it from your computer", // NEW 09-01-2026
      chooseFile: "Choose file", // NEW 09-01-2026 
      chooseAgain: "choose again" // NEW 09-01-2026
    }
  },
  // #endregion

  // #region | Motor Specs //NEW 04-12-2025
  motorSpecs: {
    general: {
      skipCnt: "recuento de saltos",
      skipTime: "tiempo de salto",
      powerConsumption: "consumo de energía",
      calibrationValue: "valor de calibración",
      rotationTime: "tiempo de rotación",
      statusMode: "modo de estado",
      noSkip: "Sin saltos",
      noPowerConsumption: "Sin consumo de energía",
      noCalibrationValue: "Sin valor de calibración",
      noRotationTime: "Sin tiempo de rotación",
      noStatusMode: "Sin modo de estado",
      pending: "pendiente",
      activated: "activado",
      skippedUntil: "Saltado hasta",
      noLiveData: "Sin datos en vivo"
    },
    terminalTypes: {
      input: "Input", //NEW 03-03-2026
      output: "Output", //NEW 03-03-2026
      buttonInput: "Button Input", //NEW 03-03-2026
      gateSensorInput: "Gate Sensor Input", //NEW 03-03-2026
      digitalInput: "Digital Input", //NEW 03-03-2026
      waterOutput: "Water Output", //NEW 03-03-2026
      inputMotor: "Input Motor", //NEW 03-03-2026
      cupMotorOutput: "Cup Motor Output", //NEW 03-03-2026
      cupMotorInput: "Cup Motor Input", //NEW 03-03-2026
      gateMotorOutput: "Gate Motor Output", //NEW 03-03-2026
      gateMotorInput: "Gate Motor Input", //NEW 03-03-2026
      rfidReader: "RFID Reader", //NEW 03-03-2026
      rfidReaderInput: "RFID Reader Input", //NEW 03-03-2026
      rfidReaderDeviceId: "RFID Reader Device ID", //NEW 03-03-2026
      sensorP: "Sensor P", //NEW 03-03-2026
      defaultMotor: "motor predeterminado",
      locationFeeder: "motor lf",
      activator: "activador",
      water: "agua"
    },
    terminalProgrammed: {
      disabled: "Desactivado",
      calibration: "Calibración",
      feedingOnFeedingTimes: "Alimentación según horarios",
      motorPassive: "Motor pasivo"
    }
  },
  // #endregion

  // #region | Params
  params: {
    animal: "Animal",
    animalId: "N.º de animal",
    animal_number: "Animal No.", // NEW 30-01-2026
    location: "Ubicación",
    location_id: "Location", // NEW 30-01-2026
    feedCurve: "Curva de alimentación",
    feedCurveId: "Foderkurve", // NEW 30-01-2026
    group: "Grupo",
    animal_group_id: "Group", // NEW 30-01-2026
    condition: "Condición",
    removeAnimals: "Mover animales",
    resetTotalConsumed: "Restablecer consumido total",
    manualFeedStart: "Inicio manual de alimentación",
    clearCalendarEvents: "Vaciar eventos del calendario",
    insemination: "Inseminación",
    weaning: "Destete",
    farrowing: "Parto",
    pregnancyCheck: "Chequeo de gestación",
    birthDate: "Fecha de nacimiento",
    pregnant: "Preñada",
    responderNo: "N.º de responder",
    responderNumber: "Responder No.", // NEW 30-01-2026
    lifeNo: "N.º de vida",
    life_number: "Life No.", // NEW 30-01-2026
    animalType: "Tipo de animal",
    milestone: "Hito",
    milestone_id: "Current milestone", // NEW 30-01-2026
    milestone_day: "Milestone day", // NEW 25-02-2026
    system: "Sistema",
    system_id: "System", // NEW 30-01-2026
    excess_remaining: "Faltan más de",
    animalRemainingToday: "Remaining today", // NEW 30-01-2026
    animalRemainingYesterday: "Remaining yesterday", // NEW 30-01-2026
    animalConsumedToday: "Consumed today", // NEW 30-01-2026
    animalConsumedYesterday: "Consumed yesterday", // NEW 30-01-2026
    animalMilestoneDay: "Current milestone day", // NEW 30-01-2026
    animalCycleDayTotal: "Total cycle day", // NEW 30-01-2026
    section: "Section", // NEW 25-02-2026
    reset_consumption: "Reset consumption", // NEW 30-01-2026
  },
  negativeParams: {
    animal: "Sin animal",
    animals: "Sin animales",
    animalId: "Sin n.º de animal",
    location: "Sin ubicación",
    feedCurve: "Sin curva de alimentación",
    group: "Sin grupo",
    condition: "Sin condición",
    component: "No Component",
    birthDate: "Sin fecha de nacimiento",
    pregnant: "No preñada",
    responderNo: "Sin n.º de responder",
    lifeNo: "Sin n.º de vida",
    animalType: "Sin tipo de animal",
    milestone: "Sin hito",
    system: "Sin sistema",
    ds: "Sin MS",
    energy: "Sin energía",
    limit: "Sin límite",
    gramPerMinute: "Sin gramos por minuto",
    priority: "Sin prioridad",
    protein: "Sin proteína",
  },
  // #endregion

  // #region | Configs //NEW 19-05-2026
  configs: {
    stationStatus: {
      creation: "Creation",
      init: "Initializing",
      termCheck: "Term Check",
      calibrate: "Calibrate",
      idle: "Idle",
      waitingTag: "Waiting Tag",
      fetchFeeding: "Fetch Feeding",
      oneFeeding: "1 Feeding",
      spray: "Spray",
      feeding: "Feeding",
      waitingLeave: "Waiting Leave",
      blocked: "Blocked",
      disabled: "Disabled",
      error: "Error",
      end: "End"
    },
    feedMotor: {
      init: "Initilazing",
      idle: "Idle",
      running: "Running",
      bookCal: "Book Calibrate",
      bookEmpty: "Book Empty",
      starting: "Starting",
      cal: "Calibrate",
      empty: "Empty",
      end: "End",
      retry: "Retry",
      safetyOne: "Safety 1",
      safetyTwo: "Safety 2",
      safetyThree: "Safety 3",
      error: "Error"
    },
    gateMotor: {
      unknown: "Unknown",
      noGate: "No Gate",
      gateClosed: "Gate closed",
      gateClosing: "Gate closing",
      gateOpen: "Gate open",
      gateOpening: "Gate opening"
    }
  },
  // #endregion

  // #region | Feed
  feed: {
    general: {
      feed: "pienso",
      feeding: "alimentación",
      remainingToday: "Restante hoy",
      remainingYesterday: "Restante ayer",
      waterUseToday: "Uso de agua hoy",
      notFed: "alimentado <20% en los dos últimos días",
      feedLastDays: "últimos 10 días",
      currentProgress: "progreso actual",
      fedLastPeriod: "alimentado último período",
      fedTotal: "alimentado total",
      feedConsumption: "consumo de pienso",
      feedBalance: "balance de pienso",
      consumedToday: "consumido hoy",
      consumedYesterday: "consumido ayer",
      expectedConsumption: "Expected Consumption", // NEW 23-04-2026
      actualConsumption: "Actual Consumption" // NEW 23-04-2026
    },
    feedCurve: {
      feedCurve: "Curva de alimentación",
      active: "activo",
      noFeedCurve: "No se encontró curva de alimentación",
      default: "predeterminada",
      minFeedSpeed: "velocidad mínima de alimentación (g/min)",
      maxFeedSpeed: "velocidad máxima de alimentación (g/min)",
      feedSpeed: "velocidad de alimentación",
    },
    feedCorrection: {
      increased: "aumentado",
      decreased: "disminuido",
      disabled: "desactivado",
      feedCorrection: "Corrección de alimentación",
      feedCorrections: "Correcciones de alimentación",
    },
    feedSkip: {
      feedSkip: "salto de alimentación",
      skipFeeding: "saltar alimentación",
      noSkip: "sin salto de alimentación",
      skipForNow: "por ahora",
      planSkip: "planificar",
      planFeedSkip: "planificar salto de alimentación",
      standardSkip: "estándar",
      startFeeding: "iniciar alimentación",
      invalidDay: "día no válido",
      invalidTime: "hora no válida",
      endDateBeforeStartDate: "la fecha de fin es anterior a la fecha de inicio",
      endTimeBeforeStartTime: "la hora de fin es anterior a la hora de inicio",
      timeSpan: "intervalo de tiempo",
      timeAmount: "cantidad de tiempo",
      startDate: "fecha de inicio",
      endDate: "fecha de fin",
      startTime: "hora de inicio",
      endTime: "hora de fin",
      plannedSkip: "salto planificado",
      recentFeedSkipSuccess: "Estado de éxito del salto de alimentación reciente",
    }
  },
  // #endregion

  // #region | Login Flow
  loginFlow: {
    def: {
      fullView: "vista completa",
      focus_view: "vista de enfoque",
      goToSiteList: "Ir a la lista de sitios",
      switchTofocus_view: "Cambiar a vista de enfoque",
      switchToFullView: "Cambiar a vista completa"
    },
    login: {
      login: "iniciar sesión",
      logOut: "Cerrar sesión",
      welcomeBack: "bienvenido de nuevo",
      notRegisteredYet: "¿Aún no estás registrado?",
      createNewuser: "crear nuevo usuario",
      forgotPassword: "¿Olvidaste la contraseña?",
      resetPassword: "restablecer contraseña",
      missingUserName: "falta el nombre de usuario",
      missingPassword: "falta la contraseña",
      couldNotLogin: "no se pudo iniciar sesión",
      noSitesFound: "no se encontraron sitios"
    },
    forgotPassword: {
      forgotPassword: "olvidé la contraseña",
      resetPassword: "restablecer contraseña",
      text: "Si no hay un correo electrónico asignado al nombre de usuario, ponte en contacto con soporte para más ayuda.",
      text2: "No cierres esta ventana antes de que finalice el proceso de restablecimiento.",
      noEmail: "Sin correo electrónico asignado",
      contactSupport: "contactar soporte",
      usernameRequired: "nombre de usuario requerido",
      noUsernameFound: "el nombre de usuario no existe"
    },
    resetPassword: {
      resetPassword: "restablecer contraseña",
      text: `Se ha enviado un código temporal a tu correo electrónico. Escríbelo a continuación para crear una nueva contraseña.`,
      temporaryCode: "Código temporal",
      newPassword: "Nueva contraseña",
      repeatPassword: "Repetir nueva contraseña",
      createNewPassword: "crear nueva contraseña",
      contactSupport: "contactar soporte",
      noPasswordRevieved: "¿No recibiste un código temporal?",
      newPasswordFail: "no se pudo crear la nueva contraseña"
    },
    createUser: {
      newUser: "usuario nuevo",
      missingUserName: "falta el nombre de usuario",
      missingPassword: "falta la contraseña",
      missingRepeatPassword: "por favor, repite la contraseña",
      passwordMismatch: "las contraseñas no coinciden",
      success: "éxito"
    },
    chooseSite: {
      chooseSite: "elegir sitio",
      siteName: "nombre del sitio",
      domain: "dominio",
      id: "id",
      tools: "herramientas"
    }
  },
  // #endregion

  // #region | Widgets
  widgets: {
    general: {
      noWidgets: "En este momento no hay widgets en esta página.",
      widgetOptions: "opciones del widget",
      manageWidgets: "gestionar",
      name: "Nombre",
      type: "Tipo",
      widgetPriority: "Prioridad",
      createNew: "crear nuevo",
      copyExisting: "copiar existente",
    },
    widgetTypes: {
      autoReports: "Informes automáticos",
      autoReportsAndMore: "Informes automáticos, etc.",
      graph: "Gráfico",
      progress: "Círculos de progreso",
    },
    graph: {
      noGraphSelected: "No se seleccionó ningún gráfico",
      graphIncludesStart: "El gráfico incluye todos los animales",
      graphIncludesEnd: "que tienen datos de consumo de pienso",
      animalsToInclude: "Animales a incluir según el sistema",
      last10Days: "Last 10 days feed consumption", //NEW 07-05-2025
      last10DaysComponent: "Last 10 days feed consumption by component", //NEW 07-05-2025
    },
    autoReports: {
      autoReports: "Informes automáticos",
      navigatedFromSystem: "Navegado desde el sistema",
      add: "Agregar informe automático",
      addExisting: "agregar existente"
    }
  },
  // #endregion

  // #region | Penlist
  penList: {
    basicDisclaimer: "Mantén el ratón sobre un valor para ver el tipo de columna",
    editDisclaimer: "Edita un animal seleccionando nuevos valores",
    addDisclaimer: "Añade un animal desde el desplegable o elimínalo de nuevo con el icono de papelera",
    moveDisclaimer: "Mueve un animal a una nueva ubicación desde el desplegable o elimínalo de cualquier ubicación con el icono de papelera",
  },
  // #endregion

  // #region | Feed Curve pages
  feedCurvePages: {
    feedCurves: {
      copyFeedCurve: "copiar curva de alimentación",
      createFeedCurve: "crear curva de alimentación",
      createFeedCurveFromScratch: "Crear curva de alimentación desde cero",
      feedCurveDetails: "detalles de la curva de alimentación",
      newFeedCurve: "nueva curva de alimentación",
      feedCurveName: "nombre de la curva de alimentación",
      fromFeedCurve: "de la curva de alimentación",
      feedCurveNameMissing: "falta el nombre de la curva de alimentación",
      goToFeedCurvePage: "ir a la página de curvas de alimentación" //NEW 11-11-2025
    },
    components: {
      components: "componentes",
      emptyText: "no se encontraron componentes",
      name: "Nombre del componente",
      readyMixture: "Listo para usar",
      priority: "Prioridad",
      ds: "MS",
      energy: "Energía",
      protein: "Proteína",
      gramPerMinute: "Gramos por minuto",
      limit: "Límite",
      newComponent: "new component" //NEW 17-04-2026
    },
    feedCurve: {
      spreading: "reparto",
      spreadings: "Repartos",
      noSpreading: "Sin reparto",
      settings: "configuración",
      day: "día",
      watchFeedCurve: "ver curva de alimentación",
      doNotPassFeed: "No pasar pienso",
      passFeed: "Pasar pienso",
      stimuli: "Estímulos",
      noStimuli: "Sin estímulos",
      addStimuli: "Añadir estímulo",
      singleStimuli: "Estímulo único",
      repeatStimuli: "Repetir estímulo",
      maxAmount: "cantidad máxima del período (kg)",
      remainingFeed: "pienso restante",
      maxFeedToPass: "kg máximos a pasar",
      max: "máx.",
      feeding: "alimentación",
      feedings: "alimentaciones",
      feedStimuli: "estímulos de alimentación",
      minutesApart: "minutos de separación",
      addTime: "añadir hora",
      saveChanges: "guardar cambios",
      resetChanges: "restablecer cambios",
      feedCurveLenght: "Longitud",
      feedLimit: "Límite de alimentación",
      animalCount: "Animales",
      consumedToday: "Consumido hoy",
      usage: "uso actual", //NEW 11-11-2025
      unknownMilestoneAndDay: "Hito y día desconocidos", // NEW 19-11-2025
      deleteFeedcurve: "eliminar curva de alimentación", // NEW 01-12-2025
      confirmDelete: "¿Seguro que quieres eliminar esta curva de alimentación?", // NEW 01-12-2025
      noFeedcurves: "No feed curves found" // NEW 25-02-2026
    }
  },
  // #endregion
  
  // #region | Animal pages
  animalPages: {
    animals: {
      animals: "animales",
      emptyText: "No se encontraron animales",
      quickEntry: "entrada rápida",
      newAnimal: "animal nuevo",
      viewChanges: "ver cambios",
      action: "acción",
      selectAnimals: "seleccionar animales",
      missingAnimalNo: "falta el n.º de animal",
      missingResponderNo: "falta el n.º de responder",
      kgFedMore: "kg alimentados por encima de lo esperado",
      noAnimalsMatchTheSelection: "Ningún animal coincide con la selección",
      responderLengt: "the responder number must be 15 characters", // NEW 29-01-2026
      lifeNoLengt: "the life number must not exceed 9 characters", // NEW 25-02-2026
      columns: "Columns", // NEW 30-01-2026
      priority: "Priority", // NEW 30-01-2026
      tablePreferences: "table preferences", // NEW 30-01-2026
      resetConsumptionDisclaimer: "Note: reset consumption only available for ESF", // NEW 30-01-2026
    },
    animalGroups: {
      group: "grupo",
      numberOfAnimals: "Número de animales",
      createGroup: "crear grupo",
      newGroup: "grupo nuevo",
      groupName: "nombre del grupo",
    },
    animal: {
      animal: "animal",
      basicInfo: "información básica",
      noAnimalSelected: "ningún animal seleccionado",
      noAnimalsSelected: "no hay animales seleccionados",
      addAnimal: "añadir animal",
      addAnimalToPen: "añadir animal al corral",
      pen: "Corral",
      moveAnimal: "mover animal",
      moveAnimals: "mover animales",
      moveAnimalFromPen: "mover animal al corral",
      goToAnimal: "ir a la página del animal",
      totalCycleDay: "día total del ciclo",
      marking: "marcado",
      noTimeline: "sin cronología",
      timeline: "cronología",
      viewTimeline: "ver cronología",
      born: "nacido",
      timelineShows: "la cronología muestra la paridad",
      parity: "paridad",
      deleteAnimal: "eliminar animal", //NEW 27-11-2025
      deleteConfirm: "¿Seguro que quieres eliminar este animal?", //NEW 27-11-2025
    }
  },
  // #endregion

  // #region | Report pages
  reportPages: {
    reports: {
      template: "Plantilla",
      templateName: "Nombre de la plantilla",
      addTemplate: "añadir plantilla",
      copyTemplate: "copiar plantilla",
      createReport: "crear informe",
      createNewReport: "Comenzar un informe nuevo desde cero",
      newTemplate: "nueva plantilla",
      newReport: "informe nuevo",
      dataLevel: "Nivel de datos",
      filterParameter: "Parámetro de filtro",
      dataParameter: "parámetro de datos",
      reportName: "nombre del informe",
      archiveReport: "archivar informe",
      startDate: "fecha de inicio",
      endDate: "fecha de fin",
      showInReport: "Mostrar en el informe",
      fromTemplate: "desde plantilla",
      noReportFound: "no se encontró informe",
      noDataParameterFound: "no se encontró parámetro de datos",
      unknownCondition: "condición desconocida",
      unknownAnimalGroup: "grupo desconocido",
      noFilterParameterFound: "no se encontraron parámetros de filtro",
      saveAsTemplate: "guardar como plantilla",
    },
    manageTemplates: { //NEW 28-11-2025
      templateOptions: "opciones de plantilla", //NEW 28-11-2025
      manageTemplates: "gestionar", //NEW 28-11-2025
      copyExisting: "copiar existente", //NEW 28-11-2025
      noTemplates: "En este momento no hay widgets en esta página.",
    }, //NEW 28-11-2025
    report: {
      report: "informe",
      editReport: "editar informe",
      unArchiveReport: "desarchivar informe",
      saveAsTemplate: "guardar como plantilla",
      noReport: "no se encontró informe",
      noReports: "No tienes informes archivados", //NEW 26-11-2025
      deleteReport: "eliminar informe", //NEW 27-11-2025
      deleteConfirm: "¿Seguro que quieres eliminar este informe?" //NEW 27-11-2025
    },
    reportColumn: {
      system: "Sistema",
      system_id: "Sistema",
      animal_id: "Animal",
      animal_button: "Animal", // NEW 02-02-2026
      location: "Ubicación",
      location_id: "Ubicación",
      section_id: "Sección",
      section: "Sección",
      feedcurve_id: "Curva de alimentación",
      feedCurveId: "Curva de alimentación",
      animal_number: "N.º de animal",
      cycle: "Ciclo",
      correction: "Corrección",
      feedcurve_milestones: "Hitos de la curva de alimentación",
      milestone_day: "Día del hito",
      condition: "Condición",
      animal_type: "Tipo de animal",
      responder_number: "N.º de responder",
      life_number: "N.º de vida",
      birthday: "Fecha de nacimiento",
      animal_group_name: "Grupo",
      milestone_name: "Hito",
      milestone_id: "Hito",
      animal_group_id: "Grupo",
      group_id: "Grupo",
      group_name: "Grupo",
      system_id_for_report: "ID de sistema para informes",
      system_name: "Sistema",
      totalPeriodConsumption: "Consumo total del período",
      consumed: "Consumido",
    },
    archive: {
      archive: "archivo",
      filterByNumber: "número de informe",
      filterByName: "nombre de informe alfabético",
      archivedReport: "Informe archivado",
      noStartDateFound: "No se encontró fecha de inicio",
      noEndDateFound: "No se encontró fecha de fin",
    },
    errorMessages: { //NEW 28-11-2025
      missingName: "falta el nombre", //NEW 28-11-2025
      missingStartDate: "falta la fecha de inicio", //NEW 28-11-2025
      missingEndDate: "falta la fecha de fin", //NEW 28-11-2025
      missingDataLevel: "falta el nivel de datos", //NEW 28-11-2025
      missingFilterParameters: "faltan parámetros de filtro", //NEW 28-11-2025
    } //NEW 28-11-2025
  },
  // #endregion

  // #region | Logbook pages
  logPages: { //NEW 27-01-2026
    logbook: { //NEW 27-01-2026
      problem: "Problem", //NEW 27-01-2026
      warning: "Warning", //NEW 27-01-2026
      info: "Info", //NEW 27-01-2026
      debug: "Debug", //NEW 27-01-2026
      system: "System", //NEW 27-01-2026
      motor: "Motor", //NEW 27-01-2026
      animal: "Animal", //NEW 27-01-2026
      time: "time", //NEW 27-01-2026
      level: "level", //NEW 27-01-2026
      type: "type", //NEW 27-01-2026
      message: "message", //NEW 27-01-2026
      location: "location", //NEW 27-01-2026
      controller: "controller", //NEW 27-01-2026
      allControllers: "all controllers", //NEW 27-01-2026
      controllerName: "controller name", //NEW 27-01-2026
      deviceName: "device name", //NEW 27-01-2026
      lanControllers: "lan controllers", //NEW 27-01-2026
      getLog: "get log", //NEW 27-01-2026
      noLogsAvailable: "No logs found", //NEW 27-01-2026
      responder: "responder", //NEW 27-01-2026
    }, //NEW 27-01-2026
  }, //NEW 27-01-2026
// #endregion
    
  // #region | Global Settings pages
  globalSettingsPages: {
    globalSettings: {
      imperial: "Imperial",
      metric: "Métrico",
      saveChanges: "guardar cambios",
      discardChanges: "descartar cambios",
      userManagement: "gestión de usuarios",
      workerManagement: "worker management", //NEW 20-01-2026
      timeZone: "zona horaria",
      feedDayStart: "inicio del día de alimentación",
      remove: "eliminar",
      emailAttentionDisclaimerWorker: "Choose which systems your worker should receive attentions from", //NEW 21-01-2026
      emailAttentionDisclaimerUser: "Choose which systems you want to receive attentions from", //NEW 21-01-2026
      settingsFor: "settings for", //NEW 20-01-2026
      systemNotifications: "system notifications" //NEW 20-01-2026
    }
  },
  // #endregion

  // #region | Location Feeder Pages
  locationFeederPages: {
    locationFeeder: {
      sections: "secciones",
      pens: "corrales",
      animals: "animales",
      sectionNo: "N.º de sección",
      pen: "Corral",
    },
    sections: {
      section: "sección",
      sections: "secciones",
      map: "mapa",
      animalAmount: "número de animales",
      penValueHeaders: "mantén el ratón sobre un valor para ver el tipo de columna",
      sectionNotFound: "sección no encontrada",
      emptyPen: "Corral vacío",
      feeder: "comedero",
      inThisPen: "en este corral",
      activations: "activaciones",
      lastActivated: "última activación",
      newSection: "nueva sección",
      sectionName: "nombre de la sección",
      firstPenNo: "primer n.º de corral",
      penAmount: "número de corrales",
      clickOnPen: "Haz clic en un corral para añadirlo o eliminarlo de nuevo.",
      penContent: "contenido del corral",
      feederOnly: "Solo comedero",
      water: "Agua",
      activator: "Activador",
      feederOutput: "Salida del comedero",
      waterOutput: "Salida de agua",
      activatorInput: "Entrada del activador",
      since: "desde",
      redirect: "Esto te redirigirá a la página del animal.",
      expand: "expandir",
      collapse: "contraer",
      noSections: "No se encontraron secciones",
      noAnimal: "Sin animal", //NEW 21-11-2025
      editSection: "edit section", //NEW 29-01-2026
      clickPen: "Click every pen you want to edit", //NEW 29-01-2026
      clicStation: "Click every station you want to edit", // 07-05-2026
      deleteSectionConfirm: "Are you sure you want to delete this section", //NEW 29-01-2026
      priority: "Priority", //NEW 02-02-2026
      sectionNameMissing: "section name missing", //NEW 05-03-2026
      pen: "Pen", //NEW 08-05-2026
    },
    settings: {
      dailyRotation: "rotación diaria",
      dailyRotationDisclaimer: "NB: Si la ubicación está vacía o el animal no tiene asignada una curva de alimentación, el motor realizará una rotación diaria con fines de servicio.",
      feedInSilos: "pienso en silos",
      attentionLimit: "límite de aviso",
      feedAmount: "cantidad de pienso", //NEW 11-11-2025
      defFeedAmount: "cantidad de pienso predeterminada (g)", //NEW 11-11-2025
      deleteSystem: "delete system", //NEW 27-11-2025
      deleteDisclaimer: "Are you sure you want to delete this system", //NEW 27-11-2025
      systemName: "system name" //NEW 11-11-2025
    }
  },
  // #endregion

  // #region | ESF Walk Through Pages
  esfWalkThroughPages: {
    esfWalkThrough: {
      pens: "pens", //NEW 11-02-2026
      station: "Station", //NEW 07-04-2026
      stations: "stations", //NEW 11-02-2026
      animals: "animals", //NEW 11-02-2026
      motor: "motor", //NEW 07-05-2026
      component: "component", //NEW 07-05-2026
      noComponent: "No component", //NEW 07-05-2026
      include: "include", //NEW 07-05-2026
    },
    sections: {
      pen: "pen", //NEW 11-02-2026
      pens: "pens", //NEW 11-02-2026
      station: "estación",
      stationFeeding: "feeding", //NEW 07-05-2026
      feedMotor: "motor de pienso",
      feedSensor: "sensor de pienso",
      gateMotor: "motor de puerta",
      gateSensor: "sensor de puerta",
      inThisStation: "en esta estación",
      previously: "anteriormente",
      feedComponents: "componentes de pienso",
      stationLastDays: "últimos 10 días",
      stationLog: "registro",
      noPens: "No pens found", //NEW 03-03-2026
      currentlyInThisPen: "currently in this pen", //NEW 07-05-2026
      animal: "Animal", //NEW 07-05-2026
      noAnimal: "No animal", //NEW 07-05-2026
      unknownAnimal: "Uknown animal", //NEW 07-05-2026
      fedToday: "fed today", //NEW 07-05-2026
      usesToday: "uses today", //NEW 07-05-2026
      stationsState: "station state", //NEW 08-05-2026
      available: "available", //NEW 08-05-2026
      consumed: "consumed", //NEW 08-05-2026
      number: "no", //NEW 08-05-2026
      water: "water", //NEW 08-05-2026
      waterAddedPrCup: "water added pr. cup", //NEW 08-05-2026
      waterDelay: "water delay", //NEW 08-05-2026
      gateAdjustment: "gate adjustment", //NEW 08-05-2026
      delayTimeClosingGate: "delay time closing gate", //NEW 08-05-2026
      indetificationValidTime: "identification valid time", //NEW 08-05-2026
      entryTime: "entry time", //NEW 08-05-2026
      feedMotors: "feed motors", //NEW 08-05-2026
      noFeedBlockTime: "no feed block time", //NEW 08-05-2026
      lastFeedBlockTime: "last feed block time", //NEW 08-05-2026
      motorComponents: "motor components", //NEW 08-05-2026
      motor: "motor", //NEW 08-05-2026
      missing: "missing", //NEW 08-05-2026
    },
    newSection: {
      firstStationNo: "first station no.", //NEW 11-02-2026
      firstColumnExit: "first column exit", //NEW 11-02-2026
      secondColumnExit: "second column exit", //NEW 11-02-2026
      numberOfFeeders: "Number of feeders", //NEW 11-02-2026
      water: "Water", //NEW 11-02-2026
      button: "Button", //NEW 11-02-2026
      waterOutput: "Water Output", //NEW 11-02-2026
      buttonInput: "Button Input", //NEW 11-02-2026
      feederOutput: "Feeder Output", //NEW 11-02-2026
      feederInput: "Feeder Input", //NEW 11-02-2026
      gateMotorOutput: "Gate Motor Output", //NEW 11-02-2026
      gateMotorInput: "Gate Motor Input", //NEW 11-02-2026
      gateSensor: "Gate Sensor", //NEW 11-02-2026
      newPen: "new pen", //NEW 27-02-2026
      penName: "pen name", //NEW 27-02-2026
      numberOfStations: "number of stations", //NEW 27-02-2026
      clickOnStation: "Click on a station to add it or remove it again.", //NEW 27-02-2026
      stationContent: "station content", //NEW 27-02-2026
      editPen: "edit pen", //NEW 03-03-2026
      clickStationToEdit: "Click every station you want to edit", //NEW 03-03-2026
      station: "Station", //NEW 03-03-2026
      penNameMissing: "pen name missing", //NEW 03-03-2026
      editFailed: "edit failed", //NEW 03-03-2026
      noStationsSelected: "no stations selected", //NEW 03-03-2026
      deletePenConfirm: "Are you sure you want to delete this pen", //NEW 03-03-2026
    },
    settings: {
    },
    systemControl: {

    }
  },
  // #endregion

  // #region | Focus View Pages
  focus_viewPages: {
    location: "ubicación",
    system: "sistema",
    section: "sección",
    inThisPen: "en este corral",
    today: "hoy",
    pen: "Corral",
    since: "desde",
    day: "Día",
    moveAnimal: "mover animal",
    newLocation: "nueva ubicación",
    emptyPen: "Corral vacío",
  }
  // #endregion
}
export default Texts